import { TankBatterySetupSizeBase } from './base/tank-battery-setup-size-base';

export class TankBatterySetupSize extends TankBatterySetupSizeBase { }